import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, FACEBOOK_COMMUNITY_URL } from '../../config/constants';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Carousel } from './Carousel';
import { FeatureList } from './FeatureList';
import { AutoPlayImage } from './AutoPlayImage';
import { Container } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import { StartPatternButton } from './StartPatternButton';
import { HowToSteps } from './HowToSteps';
import { MadeInCanada } from './MadeInCanada';
import { Faq } from './Faq';
import PatternLibraryTextLink from '../Main/Shared/PatternLibraryTextLink';
import {
	COLOR_BROWN_PRIMARY,
	COLOR_BROWN_SECONDARY,
	COLOR_FOOTER_BG,
	COLOR_FOOTER_LINK,
	GRADIENT_HERO_BG,
	GRADIENT_WARM,
	SHADOW_IMAGE_CARD,
} from '../../styles/tokens';

const footerStyle = {
	backgroundColor: COLOR_FOOTER_BG,
	color: '#FFF',
	padding: '20px 0',
	textAlign: 'center',
};

export const LandingPage = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const hash = window.location.hash;
		if (!hash) return;
		const anchor = document.getElementById(hash.slice(1));
		if (!anchor) return;
		anchor.scrollIntoView({ behavior: 'instant' });
	}, []);

	return (
		<>
			{/* Toolbar */}
			<header>
				<AppBar
					position="fixed"
					elevation={0}
					sx={{
						background: 'transparent',
						backdropFilter: 'blur(3px)',
					}}
				>
					<Toolbar
						sx={{
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						<div
							style={{
								display: 'flex',
								marginTop: '10px',
							}}
						>
							<img
								src={process.env.PUBLIC_URL + '/Logo.png'}
								alt="Fore Edge Book Art"
								style={{
									maxWidth: '50px',
									maxHeight: '50px',
								}}
							/>

							<Typography
								variant="h3"
								component="span"
								sx={{
									fontWeight: 500,
									letterSpacing: '1px',
									color: COLOR_BROWN_PRIMARY,
								}}
							>
								Fore Edge Book Art
							</Typography>
						</div>
					</Toolbar>
				</AppBar>
			</header>
			<main>
				{/* Hero */}
				<section aria-label="Hero">
					<div
						style={{
							width: '100vw',
							height: '100vh',
							backgroundImage: GRADIENT_HERO_BG,
							display: 'flex',
							flexDirection: 'column',
							overflowX: 'hidden',
							overflowY: 'hidden',
						}}
					>
						{/* Text */}
						<div
							style={{
								height: '80vh',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Typography
								variant="h2"
								component="p"
								sx={{
									typography: { xs: 'h4' },
									textAlign: 'center',
									fontWeight: 500,
									letterSpacing: '1px',
									color: COLOR_BROWN_SECONDARY,
								}}
							>
								Make your own
							</Typography>

							<Typography
								variant="h1"
								sx={{
									typography: {
										xs: 'h3',
										sm: 'h2',
										md: 'h1',
									},
									textAlign: 'center',
									fontWeight: 500,
									letterSpacing: '5px',
									color: COLOR_BROWN_PRIMARY,
									lineHeight: {
										xs: '30px',
										sm: '45px',
										md: '60px',
									},
								}}
							>
								Fore Edge Book Art
							</Typography>

							<Typography
								variant="h2"
								component="p"
								sx={{
									typography: { xs: 'h4' },
									textAlign: 'center',
									fontWeight: 500,
									letterSpacing: '1px',
									color: COLOR_BROWN_SECONDARY,
									marginBottom: '40px',
								}}
							>
								with any image
							</Typography>

							<PatternLibraryTextLink
								href={ROUTES.PATTERN_LIBRARY}
								variant="discover"
								align="center"
								sx={{ marginBottom: '30px' }}
							/>

							<Button
								variant="contained"
								size="large"
								color="primary"
								sx={{
									margin: '10px',
									fontSize: '25px',
									paddingTop: '12px',
								}}
								onClick={() => navigate('/patternmaker')}
							>
								<Typography variant="h5">
									Start Pattern Maker
								</Typography>
							</Button>

							<Typography
								variant="subtitle"
								component="p"
								sx={{
									textAlign: 'center',
									fontWeight: 500,
									letterSpacing: '1px',
									marginBottom: '40px',
									marginLeft: '20px',
									marginRight: '20px',
								}}
							>
								<i>Sign up now to get your free pattern!</i>
							</Typography>
						</div>
					</div>
				</section>
				{/* Video */}
				<section aria-label="Demo video">
					<Container
						style={{
							marginTop: '-30vh',
						}}
					>
						<CardMedia
							component="video"
							src={process.env.PUBLIC_URL + '/videos/video.webm'}
							sx={{
								boxShadow: SHADOW_IMAGE_CARD,
								borderRadius: '10px',
							}}
							autoPlay
							muted
							loop
						/>
					</Container>
				</section>
				{/* Made in Canada */}
				<MadeInCanada />
				{/* Carousel */}
				<Carousel />
				{/* Feature List */}
				<section aria-label="Features">
					<Container>
						<FeatureList />
					</Container>
				</section>
				{/* Picture */}
				<Container>
					<AutoPlayImage />
				</Container>
				{/* How to steps */}
				<section
					id="how-to"
					aria-label="How to make fore edge book art"
				>
					<Container
						style={{
							display: 'flex',
							justifyContent: 'center',
							marginBottom: '80px',
						}}
					>
						<HowToSteps />
					</Container>
				</section>
				{/* Start Pattern Maker Button */}
				<Container
					style={{
						display: 'flex',
						justifyContent: 'center',
						marginTop: '120px',
						marginBottom: '40px',
					}}
				>
					<StartPatternButton />
				</Container>
				{/* Link to Group */}
				<section aria-label="Community">
					<Container>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								marginTop: '80px',
								marginBottom: '80px',
							}}
						>
							<Typography
								variant="h2"
								style={{
									textAlign: 'center',
									lineHeight: '42px',
									marginBottom: '20px',
								}}
							>
								Join our{' '}
								<span
									style={{
										background: GRADIENT_WARM,
										WebkitBackgroundClip: 'text',
										WebkitTextFillColor: 'transparent',
									}}
								>
									vibrant
								</span>{' '}
								community
							</Typography>
							<Typography
								variant="h5"
								style={{
									maxWidth: '850px',
									textAlign: 'center',
								}}
							>
								Connect with thousands of fore edge book art
								enthusiasts worldwide! Share, learn, and
								celebrate this unique craft with friendly,
								supportive members{' '}
								<Link
									href={FACEBOOK_COMMUNITY_URL}
									underline="hover"
								>
									in our Facebook group
								</Link>
								. Whether you're a beginner or an expert,
								there's a place for you here!
							</Typography>
						</div>
					</Container>
				</section>
				{/* Carousel */}
				<Carousel />
				{/* FAQ */}
				<section id="faq" aria-label="Frequently asked questions">
					<Container
						style={{
							display: 'flex',
							marginBottom: '40px',
						}}
					>
						<Faq />
					</Container>
				</section>
				{/* Footer */}
				<footer style={footerStyle}>
					<Typography variant="h5">
						Like us on{' '}
						<Link
							href="https://www.facebook.com/ForeEdgeBookArt"
							underline="hover"
							sx={{ color: COLOR_FOOTER_LINK }}
						>
							Facebook
						</Link>
					</Typography>
					<Typography variant="h6">
						Have questions? Contact{' '}
						<Link
							href="mailto:matt@foreedgebookart.com"
							underline="hover"
							sx={{ color: COLOR_FOOTER_LINK }}
						>
							Matt@ForeEdgeBookArt.com
						</Link>
					</Typography>
				</footer>
			</main>
		</>
	);
};
